module.exports = __webpack_public_path__ + "assets/c341f12f93637cd192ce165440de4c9c.png";